module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin-red-8834282611394a559a0717b79f5c5e6c.png";